import { req } from '../../@api/request';

export default class StudyroomService {
  static terms = async (consonant: string, search?: string) => {
    const result = await req.get2('/studyroom', {
      params: {
        ...(consonant && { consonant }),
        ...(search && { search }),
      },
    });
    return result.data;
  };

  static forms = async (page: number, search?: string) => {
    const result = await req.get2(`/studyroom/form?page=${page}`, {
      params: search ? { search } : {},
    });
    return result.data;
  };

  static downloadHref = (idx: number, type: 'hwp' | 'doc') => {
    return `${process.env.REACT_APP_HOST_API}studyroom/form/${idx}/${type}`;
  };
}
